<template>
  <div>
    <div class="header">
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="项目库页面设置"
          name="/operate/pageManage/invest"
        ></el-tab-pane>
        <el-tab-pane
          label="资金库页面设置"
          name="/operate/pageManage/financing"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: this.$route.path,
    };
  },
  methods: {},
  mounted() {},
  watch: {
    activeName: {
      handler(val, ovl) {
        this.$router.push(val);
      },
    },
    $route(to, from) {
      //监听路由是否变化
      this.activeName = to.path;
      if (to.query.key != from.query.key) {
        this.activeName = to;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.header {
  padding: 20px;
  margin-bottom: 20px;
  background-color: #ffffff;
}
</style>